import React from 'react'
import styled from 'styled-components'

export const BoxStyle = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 0.75rem;
  background: white;
`

const Wrapper = styled(BoxStyle)`
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: hidden;
  margin: 0 -0.75rem;
  flex: 1;
`

const HeaderWrapper = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
`

type THeader = {
  children?: React.ReactNode
  className?: string
  [key: string]: any
}

type TBox = {
  children?: React.ReactNode
  header?: string | React.ReactNode
  [key: string]: any
}

export const Header = ({
  children,
  className,
  ...rest
}: THeader): React.ReactElement => (
  <HeaderWrapper className={`${className || ''} mb-2`} {...rest}>
    <h4 className="m-0 mx-2 mb-2 mt-1">{children}</h4>
  </HeaderWrapper>
)

const Content = styled.div`
  overflow-y: auto;
  flex: 1;
  flex-direction: column;
  display: flex;
`

// TODO: WTF DOES THIS EVEN EXIST?
const Box = (props: TBox): React.ReactElement => {
  const { children, header, ...rest } = props

  if (header) {
    return (
      <Wrapper>
        <Body>
          <Header>{header}</Header>
          <Content>
            <div
              className="px-2 d-flex flex-fill flex-column"
              style={{ overflowY: 'auto' }}
            >
              {children}
            </div>
          </Content>
        </Body>
      </Wrapper>
    )
  }
  return <BoxStyle {...rest}>{children}</BoxStyle>
}

export default Box
